(() => {
  if (window.yunshoKnowledgeMotion) return;
  const roots = new WeakSet();
  const finished = new WeakSet();
  const active = new Set();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(width < 768px)');
  const selector = '[data-knowledge-motion]';

  function cancelActive() {
    active.forEach(animation => animation.cancel());
    active.clear();
  }

  function initialize(root) {
    if (roots.has(root)) return;
    roots.add(root);
    root.dataset.knowledgeMotionReady = 'true';
    const media = root.dataset.knowledgeMotion === 'category'
      ? [...root.querySelectorAll('figure.photo:not(.cover)')]
      : [...root.querySelectorAll('[data-knowledge-media] > figure')];
    media.forEach(element => { element.dataset.knowledgeReveal = 'idle'; });
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) {
      media.forEach(element => { element.dataset.knowledgeReveal = 'unsupported'; });
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || finished.has(entry.target)) return;
        const element = entry.target;
        finished.add(element);
        observer.unobserve(element);
        if (reduced.matches) {
          element.dataset.knowledgeReveal = 'reduced';
          return;
        }
        const offset = mobile.matches ? 0 : 8;
        element.dataset.knowledgeReveal = 'played';
        element.dataset.knowledgeRevealCount = '1';
        try {
          const animation = element.animate([
            { opacity: 0.5, transform: `translateY(${offset}px)` },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 400, easing: 'cubic-bezier(.2,.6,.2,1)', iterations: 1 });
          active.add(animation);
          animation.finished.catch(() => {}).finally(() => active.delete(animation));
        } catch {
          element.dataset.knowledgeReveal = 'unsupported';
        }
      });
    }, { threshold: 0.08 });
    media.forEach(element => {
      const bounds = element.getBoundingClientRect();
      if (bounds.height && bounds.top < window.innerHeight && bounds.bottom > 0) {
        finished.add(element);
        element.dataset.knowledgeReveal = 'initial-viewport';
      } else observer.observe(element);
    });
  }

  function scan(container = document) {
    if (container.matches?.(selector)) initialize(container);
    container.querySelectorAll(selector).forEach(initialize);
  }

  reduced.addEventListener('change', cancelActive);
  mobile.addEventListener('change', cancelActive);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pagehide', cancelActive);
  window.yunshoKnowledgeMotion = { scan };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else scan();
})();
